import { render, staticRenderFns } from "./PartyBuildingWork.vue?vue&type=template&id=d9b8c8ca&scoped=true&"
import script from "./PartyBuildingWork.vue?vue&type=script&lang=js&"
export * from "./PartyBuildingWork.vue?vue&type=script&lang=js&"
import style0 from "./PartyBuildingWork.vue?vue&type=style&index=0&id=d9b8c8ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b8c8ca",
  null
  
)

export default component.exports